import { createAction } from 'redux-actions'

export const onFlashTurnOn = createAction<boolean>('ON_FLASH_TURN_ON')
export const onFlashUpdate = createAction<boolean>('ON_FLASH_UPDATE')
export const onFlashProgressStateUpdate = createAction<boolean>('ON_FLASH_PROGRESS_STATE_UPDATE')
